import { fromJS, Record } from 'immutable';

import PromoRecord from './promo';
import TestGroupRecord from './test_group';
import { subDomains } from '../lib/constants/SiteVariables';
import { convertRawValues } from '../lib/utils/record_utils';

export default class SessionRecord extends Record({
  id: null,
  disposition: '',
  application_id: null,
  company_id: null,
  merchant_id: null,
  shopping_cart_id: null,
  user_id: null,
  prequalified_user_id: null,
  promo_id: null,
  promo: null,
  public_key: '',
  session_type: null,
  standalone_type: null,
  workflow: '',
  action: '',
  mode: '',
  strategy: '',
  referring_session_id: null,
  customer_checkout_url: null,
  pay_now_handoff: null,
  session_key: null,
  custom_flags: [],
  invite_slug: null,
  oscilar_fraud_ids: fromJS({}),
  test_group: null,
}) {
  constructor(data) {
    data = convertRawValues(data);

    if (data && data.get('promo')) {
      data = data.set('promo', new PromoRecord(data.get('promo')));
    }

    if (data && data.get('test_group')) {
      data = data.set(
        'test_group',
        new TestGroupRecord(data.get('test_group'))
      );
    }

    super(data);
  }

  depId(dep) {
    if (!this.has(dep + '_id')) throw new Error('invalid dependency');

    return this[dep + '_id'] ? this[dep + '_id'] : null;
  }

  loadDep(type, dispatch, action) {
    if (!this.has(type + '_id')) throw new Error('invalid dependency');

    return this.depId(type) && dispatch(action(this.depId(type)));
  }

  hasApplication() {
    return !!(this.has('application_id') && this.application_id);
  }

  hasShoppingCart() {
    return !!(this.has('shopping_cart_id') && this.shopping_cart_id);
  }

  currentRoute() {
    if (!this.has('workflow') || !this.has('action')) return null;

    return `/${this.workflow}/${this.action}`;
  }

  hasCustomFlag(flag) {
    return this.custom_flags.includes(flag);
  }

  setCustomFlag(flag) {
    if (!subDomains.authorized(flag)) return this;

    return this.set('custom_flags', [...new Set(this.custom_flags.push(flag))]);
  }

  removeCustomFlag(flag) {
    if (!this.custom_flags.includes(flag)) return this;

    const index = this.custom_flags.indexOf(flag);
    return this.set('custom_flags', [
      ...new Set(this.custom_flags.splice(index, 1)),
    ]);
  }
}
